import { createRef, useRef, useState } from "react";
import { Link, Router, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { TextInput } from "../../../components/formLibs/FormLibs";
import "primeicons/primeicons.css";
import logoEcole229 from "../../../assets/images/logo.jpg";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import Authentification from "../../../api/Authentification";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { routes } from "../../../routes";

export default function Register() {
  const [iconPassword, setIconPassword] = useState(false);
  const [typeFieldPassword, setTypeFieldPassword] = useState(false);
  const [checked, setChecked] = useState(false);
  const recaptchaRef = createRef();
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const schema = Yup.object({
    firstname: Yup.string()
      .required("Le prénom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    lastname: Yup.string()
      .required("Le nom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    email: Yup.string()
      .required("L'email est obligatoire")
      .email("Email invalide"),
    password: Yup.string()
      .required("Le mot de passe est obligatoire")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&-+=()!]).{8,24}$/,
        { message: "Mot de passe trop faible" }
      ),
    password_confirmation: Yup.string()
      .required("Confirmez le mot de passe")
      .oneOf([Yup.ref("password"), null], "Mot de passe différent"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const handleCLickIconPasswords = (e) => {
    e.preventDefault();
    setIconPassword(!iconPassword);
    setTypeFieldPassword(!typeFieldPassword);
  };

  const registerData = (data) => {
    setLoading(true);
    const recaptchaValue = recaptchaRef.current.getValue();
    if (!recaptchaValue) {
      toast.current.show({
        severity: "warn",
        summary: "Avertissement",
        detail: "Veuillez valider le captcha svp !",
        life: 3000,
      });
      setLoading(false);
    } else {
      Authentification.register(data)
        .then((res) => {
          if (res.data.error) {
            toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Erreur de validation",
              life: 3000,
            });
            setLoading(false);
          } else {
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail:
                "Inscription réussie. Veuillez consulter voitre bote mail pour activer votre compte. Merci !",
              life: 5000,
            });
            reset();
            setTimeout(() => {
              navigate("/auth/login");
            }, 5000);
            setLoading(false);
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Erreur de validation",
            life: 3000,
          });
          setLoading(false);
        });
    }
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="auth__logo">
        <img src={logoEcole229} alt="logo_ecole229" />
      </div>
      <p className="mb-5 subtitle text-center">
        Renseignez vos informations pour vous inscrire !
      </p>
      <div className="auth__form">
        <form className="form" onSubmit={handleSubmit(registerData)}>
          <div className="form__item">
            <label htmlFor="lastname">Nom</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="lastname"
                label="lastname"
                register={register}
              />
              <i className="pi pi-user"></i>
            </div>
            <ErrorMsg>{errors?.lastname?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="firstname">Prénom(s)</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="firstname"
                register={register}
                label="firstname"
              />
              <i className="pi pi-user"></i>
            </div>
            <ErrorMsg>{errors.firstname?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="email">Email</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="email"
                register={register}
                label="email"
              />
              <i className="pi pi-envelope"></i>
            </div>
            <ErrorMsg>{errors.email?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="password">Mot de passe</label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password"
                label="password"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <a
                href="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </a>
            </div>
            <ErrorMsg>{errors.password?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="password_confirmation">
              Confirmer mot de passe
            </label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password_confirmation"
                label="password_confirmation"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <Link
                to="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </Link>
            </div>
            <ErrorMsg>{errors.password_confirmation?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              ref={recaptchaRef}
            />
          </div>
          <div className="form__item">
            <button type="submit">
              S'inscrire{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
          <div className="form__item form__item--last">
            <p>
              Vous avez déjà un compte ?{" "}
              <Link to={routes.auth + routes.login}>Se connecter</Link>
            </p>
          </div>
        </form>
      </div>
    </>
  );
}
